'use client';

import { useEffect, useSyncExternalStore } from 'react';

const YOTPO_APP_KEY = process.env.NEXT_PUBLIC_YOTPO_APP_KEY;

export default function YotpoStars({ productId, url }) {
  const mounted = useSyncExternalStore(() => () => {}, () => true, () => false);

  useEffect(() => {
    if (!mounted || !productId) return;

    let cancelled = false;
    let attempts = 0;
    let timerId;
    const MAX_ATTEMPTS = 50;

    const refresh = () => {
      if (cancelled) return;

      if (typeof window.yotpo?.refreshWidgets === 'function') {
        try {
          window.yotpo.refreshWidgets();
        } catch {
          // Legacy loader not ready.
        }
        return;
      }

      if (attempts++ < MAX_ATTEMPTS) {
        timerId = setTimeout(refresh, 200);
      }
    };

    refresh();

    return () => {
      cancelled = true;
      clearTimeout(timerId);
    };
  }, [mounted, productId]);

  if (!productId) return null;

  return (
    <div className="min-h-[19px]">
      {mounted ? (
        <div
          className="yotpo bottomLine flex items-center"
          {...(YOTPO_APP_KEY ? { 'data-appkey': YOTPO_APP_KEY } : {})}
          data-product-id={productId}
          {...(url ? { 'data-url': url } : {})}
        />
      ) : null}
    </div>
  );
}
